import { withTranslation } from "next-i18next";
import { memo } from "react";
import { useFiltersList } from "@hooks/use-features";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import FilterRadio from "./Elements/FilterRadio";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;
const filterSectionKey = "kinds";

const KindsSection = memo(function KindsSection({
  kindsItems,
  uiState,
  setUiState,
  listingPage,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
  t,
}) {
  const filtersList = useFiltersList();

  if (kindsItems.length < 2) return null;
  if (shouldHideFilterSectionInListingPage(listingPage, "kinds")) return null;

  const sectionTitle = t(`catalog:filters.section_titles.${filterSectionKey}`);

  function updateFiltersOnKinds(kinds) {
    setUiState({
      ...uiState,
      [mainIndex]: {
        ...uiState[mainIndex],
        refinementList: {
          ...uiState[mainIndex].refinementList,
          segment: kinds,
        },
      },
    });
  }

  function displayKindsFiltersOptions() {
    return filtersList.kinds.map((filter) => {
      const item = kindsItems.find((item) => item.value === filter);

      if (!item) return;

      return (
        <FilterRadio
          key={`filter-kinds-${filter}`}
          id={`filter-kinds-${filter}`}
          label={t(`catalog:filters.kinds.${filter}`)}
          filterType="kinds"
          filterSectionKey={filterSectionKey}
          item={item}
          onClick={() => updateFiltersOnKinds([filter])}
        />
      );
    });
  }

  const checkedFilters = {
    kinds: filtersList.kinds.filter(
      (kind) => kindsItems.find((item) => item.value === kind)?.isRefined,
    ),
  };

  return (
    <div>
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["kinds"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />

      <SectionContent
        isOpen={filterSectionOpened === filterSectionKey}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("")}
        title={sectionTitle}
      >
        <FilterRadio
          key="filter-kinds-all"
          id="filter-kinds-all"
          label={t("catalog:filters.kinds.all")}
          filterType="kinds"
          filterSectionKey={filterSectionKey}
          item={{ isRefined: !checkedFilters.kinds?.length, label: "all", value: "all" }}
          onClick={() => updateFiltersOnKinds([])}
        />
        {displayKindsFiltersOptions()}
      </SectionContent>
    </div>
  );
});

export default withTranslation("catalog")(KindsSection);
